<template>
    <div class="main">
        <h1 style="margin-bottom: 30px;">文创上新</h1>
        <div class="demo-login">
            <Login @on-submit="handleSubmit">
                <UserName name="account" />
                <Password name="password" />
                <Submit :loading="submit"/>
            </Login>
        </div>
    </div>
</template>
<script>
import { loginByUsername } from "@/api/login/login";

export default {
    data() {
        return {
            autoLogin: true,
            submit: false
        }
    },
    methods: {
        handleSubmit(valid, { account, password }) {
            if (valid && !this.submit ) {
                this.submit = true
                loginByUsername(account, password).then(res => {
                    this.submit = false
                    if (res && res.code == 0) {
                        this.$store.dispatch('updateToken', res.data.token)
                        this.$store.dispatch('updateUserInfo', res.data.user)
                        localStorage.setItem('token', res.data.token);
                        localStorage.setItem('userInfo', JSON.stringify(res.data.user));
                        this.$router.push('/')
                    }
                })
            }
        }
    }
}
</script>
<style>
.main {
    width: 100%;
    height: 100vh;
    background: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}

.demo-login {
    width: 400px;
    margin: 0 auto !important;
    background: #ffffff;
    padding: 30px 50px;
    border-radius: 10px;
}

.demo-auto-login {
    margin-bottom: 24px;
    text-align: left;
}

.demo-auto-login a {
    float: right;
}
</style>
